import { render, staticRenderFns } from "./ReviewsPrev.vue?vue&type=template&id=4f3914eb&"
import script from "./ReviewsPrev.vue?vue&type=script&lang=ts&"
export * from "./ReviewsPrev.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports